import { Injectable } from '@angular/core';
import { ConnectionService } from '../connection-service';
import { WindowRefService } from '../window-ref-service';
import { Broadcaster } from '../../components/broadcaster';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class ValidationService {
  constructor(
    private readonly connectionService: ConnectionService,
    private readonly broadcasterService: Broadcaster,
    private readonly appConfig: AppConfig,
    private readonly windowService: WindowRefService) {
  }
  validateMargId(margIds_: string): boolean {
    const margIds = margIds_.split('|').map((each: string) => parseInt(each, 10));
    if (margIds.some((id: number) => id <= 0)) { return false; }
    return true;
  }

  async validateScreenSize(): Promise<void> {
    const isSmallScreenExperimentEnabled = await this.connectionService.findExperiment({
      where: { key: 'disableSmallScreenExperiment', enable: true },
      project: ['key'],
    });
    if (this.windowService.nativeWindow.screen.width < 1000 && isSmallScreenExperimentEnabled) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'This Page is not supported on current screen',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      throw new Error('This Page is not supported on current screen');
    }
  }
}
